"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
var Features;
(function (Features) {
    Features["ActivateHcLogsForEaaWeb"] = "activate-HC-logs-for-EAA-WEB";
    Features["RfaActivateClientOnlyRouting"] = "rfa-activate-client-only-routing";
    Features["ActivateAppointmentBannerForRFA"] = "activate-appointment-banner-for-rfa";
    Features["ActiveInAdviceNudge"] = "active-in-advice-nudge";
    Features["AdobeAnalytics"] = "adobe-analytics";
    Features["AllowMtwMfe"] = "ALLOW_MTW_MFE";
    Features["AllowPilotAccess"] = "allow-pilot-access";
    Features["AllowRetakeRiskQuizGame"] = "allow-retake-risk-quiz-game";
    Features["Apollo"] = "apollo";
    Features["ApolloBalanceRuleException"] = "apollo-balance-rule-exception";
    Features["ApolloDashboardAdvisorCard"] = "apollo-dashboard-advisor-card";
    Features["ApolloSchedulingNudge"] = "apollo-scheduling-nudge";
    Features["ApolloPartnerBenefitsCard"] = "apollo-partner-benefits-card";
    Features["ApolloPartnerBenefitsNudge"] = "apollo-partner-benefits-nudge";
    Features["AxeAccountsAdapterUseKongUrl"] = "axe-accounts-adapter-use-kong-url";
    Features["ClientDCT"] = "client-webservice-dct";
    Features["ClientWCA"] = "client-wca";
    Features["ContributionsExperiment"] = "contributions-experiments";
    Features["CSATSurveyTakeoverHierarchy"] = "csat-survey-takeover-hierarchy";
    Features["CustomGoalBrochureUpdate"] = "custom-goal-brochure-update";
    Features["DashboardAipNudge"] = "dashboard-aip-nudge";
    Features["DashboardMultigoalNudge"] = "dashboard-multi-goal-nudge";
    Features["DashboardWelcomeCarousel"] = "dashboard-welcome-carousel";
    Features["PostEnrollmentPAOfferSwitch"] = "post-enrollment-pa-offer-switch";
    Features["PASchedulingBanner"] = "oa-pa-scheduler-banner";
    Features["DapMonorepoContentServiceV2"] = "dap-monorepo-content-service-v2";
    Features["DisplayContributeCashMfe"] = "display-contribute-cash-mfe";
    Features["DisplayWithdrawalCashMfe"] = "display-withdrawal-cash-mfe";
    Features["DisplayManageTransferMfe"] = "display-manage-transfer-mfe";
    Features["DisplayPortfolioLink"] = "display-portfolio-link";
    Features["EligibilityOAuth"] = "eligibility-oauth";
    Features["EnableAddAggregatedAccounts"] = "enable-add-aggregated-accounts";
    Features["EnableAddSpouse"] = "enable-add-spouse";
    Features["EnableOGCContentInRiskQuiz"] = "enable-ogc-content-in-risk-quiz";
    Features["EnableCustomGoalCreation"] = "enable-custom-goal-creation";
    Features["EnableCustomGoalCreationAfter55"] = "enable-custom-goal-creation-after-55";
    Features["EnableCustomGoalCreationForIRAOnly"] = "enable-custom-goal-creation-for-ira-only";
    Features["EnableEducationGoals"] = "enable-education-goals";
    Features["EnableDagMultiRegion"] = "enable-dag-multi-region";
    Features["EnableESGPageForPYMTW"] = "enable-ESG-page-for-PYMTW";
    Features["EnableFirstMonthExperienceDapMonorepo"] = "enable-first-month-experience-dap-monorepo";
    Features["EnableFL0Zoom"] = "enable-fl0-zoom";
    Features["EnableGlobalNavUnifiedHeaderFooter"] = "enable-global-nav-unified-header-footer";
    Features["EnableGoalsInRetirementForPAClientsOnly"] = "enable-goals-in-retirement-for-pa-clients-only";
    Features["EnableLoggingInRiskQuiz"] = "enable-logging-in-risk-quiz";
    Features["EnableMAGModuleFederation"] = "enable-mag-module-federation";
    Features["EnableMockServicesForDA"] = "enable-mock-services-for-da";
    Features["EnablePostConversionFlow"] = "enable-post-conversion";
    Features["EnableQKUModuleFederation"] = "enable-qku-module-federation";
    Features["EnableResourceCenterMonorepoMfe"] = "enable-resource-center-monorepo-micro-frontend";
    Features["EnableScreenTakeoverHierarchyMfe"] = "enable-screen-takeover-hierarchy-mfe";
    Features["EnableTradeoffExperienceMFE"] = "enable-mtq-mfe";
    Features["EnableRMD"] = "enable-rmd";
    Features["EnableSpousalView"] = "enable-huu-spousal-view";
    Features["EnableVortexFeeWaiver"] = "Enable_Vortex_Fee_Waiver";
    Features["EnableAxeFourAndNinePartial"] = "enable-axe-four-and-nine-partial";
    Features["FirstMonthExperience"] = "first-month-experience";
    Features["FirstMonthExperienceEmergencySavingsCard"] = "first-month-experience-emergency-savings-card";
    Features["FinancialProfileEdit"] = "financial-profile-edit";
    Features["FeePromotionPA"] = "Fee-Promotion-PA";
    Features["FeeWaiverPersonalAdvisorRetail"] = "FeeWaiverPersonalAdvisorRetail";
    Features["FeeWaiverVmapUI"] = "Fee-Waiver-VMAP-UI";
    Features["FeeWaiverV2EndPoint"] = "FeeWaiverV2EndPoint";
    Features["FL0SendGPOVCMMOverride"] = "fl0-use-new-vcmm-override";
    Features["FtwManageTransfer"] = "ftw-manage-transfer";
    Features["GetCash"] = "get-cash";
    Features["HoneycombLogsForMTWUi"] = "honeycomb-logs-for-MTW-ui";
    Features["IncludeAggregationInRetirementFlow"] = "include-aggregation-in-retirement-flow";
    Features["IncludeDebt"] = "include-debt";
    Features["JuneBrochureAndServiceAgreement"] = "june-brochure-and-service-agreement";
    Features["JWTCacheEnabled"] = "jwt-cache-enabled";
    Features["MockRepliesFromClientPreferencesKd0"] = "mock_replies_from_clientPreferences_kd0";
    Features["MockResponseForAAT"] = "mock-response-for-aat";
    Features["MockResponseForAccountsServices"] = "mock-out-accounts-services";
    Features["MockResponseForAEG"] = "mock-response-for-aeg";
    Features["MockResponseForECG"] = "mock-response-for-ecg";
    Features["MockResponseForAIP"] = "mock-response-for-aip";
    Features["MockResponseForSJS"] = "mock-response-for-sjs";
    Features["MockResponseForZPU"] = "mock-response-for-zpu";
    Features["MoveClientContributions"] = "move-client-contributions";
    Features["MtwMfeChooseAccountsIntro"] = "mtw-mfe-choose-accounts-intro";
    Features["MtwMfeManagedAccounts"] = "mtw-mfe-managed-accounts";
    Features["NewGlobalNavForOnboarding"] = "new-global-nav-for-onboarding";
    Features["NextStepsDone"] = "next-steps-done";
    Features["OfferDowngradePilot"] = "offer-downgrade-pilot";
    Features["OfferSwitchActivityLog"] = "offer-switch-activity-log";
    Features["OfferUpgradeDowngrade"] = "offer-upgrade-downgrade";
    Features["OfferUpgradeDowngradeAutomaticTakeover"] = "upgrade-pilot-entry";
    Features["OfferUpgradeForIneligible"] = "offer-upgrade-for-ineligible";
    Features["OpenBankingNudge"] = "open-banking-nudge";
    Features["PDNAvailable"] = "PDN-Available";
    Features["PortfolioBuilderAiA"] = "portfolio-builder-allow-aia";
    Features["PAUnenrollToggle"] = "personal-advisor-unenroll";
    Features["UnenrollMedalliaSurvey"] = "enable-unenroll-medallia-survey";
    Features["RedirectToDigitalAdvisor"] = "redirect-to-digital-advisor";
    Features["RedirectToECSDigitalAdvisor"] = "redirect-to-ecs-digital-advisor";
    Features["RedirectToOfferRealignment"] = "redirect-to-offer-realignment";
    Features["RetireeDrawdown"] = "retiree-drawdown";
    Features["RetireeIntercept"] = "retiree-intercept";
    Features["ReviewContributionsPage"] = "enable-review-contributions-page";
    Features["RevisitRetirement"] = "revisit-retirement";
    Features["SalaryBonus"] = "salary-and-bonus";
    Features["SalesOnboardingPhoneNumberDA"] = "da-so-phone";
    Features["SalesOnboardingPhoneNumberPA"] = "pa-so-phone";
    Features["SeptemberBrochureAndServiceAgreement"] = "invest-brochure-sept";
    Features["ShowActivityLog"] = "show-activity-log";
    Features["ShowActivityLogMfe"] = "show-jfd-activity-log-mfe";
    Features["ShowClientNotificationBanner"] = "client-notification-banner";
    Features["ShowFeePromoContent"] = "show-fee-promo-content";
    Features["ShowFirstVisitExitSurvey"] = "show-first-visit-exit-survey";
    Features["ShowMarketVolatilityContent"] = "show-market-volatility-content";
    Features["ShowSupportedBrowsersPage"] = "show-supported-browsers-page";
    Features["ShowTempOutagePage"] = "show-temp-outage-page";
    Features["SmartSellDown3"] = "enable-smart-sell-down-3";
    Features["TaxLossOption"] = "enable-tlh-micro-frontend";
    Features["TaxLossOptionNudge"] = "enable-tlh-banner-nudge";
    Features["ToggleGoalSolverComponents"] = "toggle_for_the_goal_solver_components";
    Features["ToolsDebtCalculator"] = "Enable-Debt-Calculator-On-Resources-Page";
    Features["ToolsPage"] = "enable-tools-page";
    Features["ToolsHccePage"] = "enable-tools-hcce-page";
    Features["UseAxeAccounts"] = "use-axe-accounts";
    Features["UseNewJWTAuthToken"] = "use-new-jwt-auth";
    Features["UseOnlyApiGUrlToEs2"] = "use-only-apig-url-to-es2";
    Features["UseServerlessYAK"] = "use-serverless-yak";
    Features["UpgradePilotBannerNudge"] = "upgrade-pilot-banner-nudge";
    Features["VmapPostConversionExperiment"] = "vmap-post-conversion-experiment";
    Features["VmapEsetupData"] = "vmap-esetup-data";
    Features["WithdrawCashLinkIraOnly"] = "withdraw-cash-link-ira-only";
    Features["MyPlanPageMfe"] = "enable-zs0-mfe";
    Features["FastPathEnrollmentExperiment"] = "fast-path-enrollment-experiment";
    Features["FastPathProspect"] = "fast-path-prospect";
    Features["ActiveInFastPath"] = "active-in-fast-path";
    Features["EnableOmnichanelTlhNudgesExperiment"] = "enable-omnichannel-tlh-nudges-experiment";
})(Features = exports.Features || (exports.Features = {}));
